import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from "@mui/material";

const Acceso = ({ handleClose }) => {
  const menuItems = [
    {
      text: "Reglamento de Protección al Usuario",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2021/reglamentoproteccionalusuariounificado.pdf",
    },
    {
      text: "Portabilidad Numérica",
      link: "http://www.conatel.gob.hn/doc/resoluciones/2021/ReglamentoPortabilidad.pdf",
    },
    {
      text: "Tarifas",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2017/NR008-17.pdf",
    },
    {
      text: "Lista Negra (IMEI)",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2014/NR009-14.pdf",
    },
    {
      text: "Procedimiento Administrativo Contra el Fraude",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2014/NR024-14.pdf",
    },
    {
      text: "Compensación por Llamadas Caídas",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2014/NR033-14.pdf",
    },
    {
      text: "Reglamento de Prepago",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2017/NR008-17.pdf",
    },
    {
      text: "Roaming",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2014/NR022-14.pdf",
    },
    {
      text: "Reglamento de Proveedores de Contenido",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2015/NR004-15.pdf",
    },
    {
      text: "Reglamento de Prestación de Servicios de Mensaje y Acceso a Contenido",
      link: "http://www.conatel.gob.hn/doc/Regulacion/resoluciones/2015/NR016-15.pdf",
    },
  ];

  return (
    <Box
      sx={{
        mt: 2,
        mx: "auto",
        width: "80%",
        maxWidth: 600,
        textAlign: "center",
      }}
    >
      <Typography variant="h4" gutterBottom>
        ACCESO A RESOLUCIONES DE INTERÉS DEL USUARIO
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box
        component="img"
        src="../../assets/documentos.png"
        alt="Imagen de referencia"
        sx={{
          width: "30%",
          height: "auto",
          mb: 2,
        }}
      />
      <List>
        {menuItems.map((item, index) => (
          <ListItem
            button
            component="a"
            href={item.link}
            target="_blank"
            key={index}
            sx={{ justifyContent: "center" }}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          CERRAR
        </Button>
      </Box>
    </Box>
  );
};

export default Acceso;
